import { render, staticRenderFns } from "./ItemQuantity.vue?vue&type=template&id=51b95aca&scoped=true&"
import script from "./ItemQuantity.vue?vue&type=script&lang=js&"
export * from "./ItemQuantity.vue?vue&type=script&lang=js&"
import style0 from "./ItemQuantity.vue?vue&type=style&index=0&id=51b95aca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b95aca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTextField})
